import { render, staticRenderFns } from "./geo.vue?vue&type=template&id=4860d6d2&scoped=true&"
import script from "./geo.vue?vue&type=script&lang=js&"
export * from "./geo.vue?vue&type=script&lang=js&"
import style0 from "./geo.vue?vue&type=style&index=0&id=4860d6d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4860d6d2",
  null
  
)

export default component.exports